let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("keP0k")).then(() => parcelRequire('ix1Mi'));